import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 日付データをJSTに変換して返す
 * @param date
 * @param format
 */
export const ConvertJST = (date: Date, format: string) => {
  return dayjs(date).tz("Asia/Tokyo").format(format);
}
